// components/ConsultationFailed.jsx
import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { XCircle, Home, RefreshCw } from 'lucide-react';

const ConsultationFailed = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  const code = searchParams.get('code');

  const getErrorMessage = () => {
    switch (reason) {
      case 'cancelled':
        return {
          title: 'پرداخت لغو شد',
          message: 'شما فرآیند پرداخت را لغو کردید',
          icon: '🚫'
        };
      case 'verify_failed':
        return {
          title: 'تأیید پرداخت ناموفق',
          message: 'متأسفانه تأیید پرداخت با خطا مواجه شد',
          icon: '❌'
        };
      case 'not_found':
        return {
          title: 'سفارش یافت نشد',
          message: 'اطلاعات سفارش در سیستم موجود نیست',
          icon: '🔍'
        };
      default:
        return {
          title: 'خطای پرداخت',
          message: 'متأسفانه مشکلی در پرداخت به وجود آمد',
          icon: '⚠️'
        };
    }
  };

  const error = getErrorMessage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4" dir="rtl">
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-2xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-gradient-to-l from-red-500 to-red-600 p-8 text-white text-center">
          <div className="text-6xl mb-4">{error.icon}</div>
          <h1 className="text-2xl font-bold mb-2">{error.title}</h1>
          <p className="text-red-100">{error.message}</p>
        </div>

        {/* Body */}
        <div className="p-8">
          
          {code && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
              <p className="text-sm text-red-700">
                کد خطا: <span className="font-mono font-bold">{code}</span>
              </p>
            </div>
          )}

          <div className="space-y-4 mb-6">
            <p className="text-slate-700">
              در صورت کسر وجه از حساب شما، مبلغ ظرف 72 ساعت به حساب شما بازگردانده خواهد شد.
            </p>
            <p className="text-slate-600 text-sm">
              اگر مشکل ادامه داشت، لطفاً با پشتیبانی تماس بگیرید.
            </p>
          </div>

          {/* دکمه‌ها */}
          <div className="space-y-3">
            <Link
              to="/consultation"
              className="w-full bg-gradient-to-l from-green-500 to-green-600 text-white font-bold py-4 rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <RefreshCw size={20} />
              تلاش مجدد
            </Link>

            <Link
              to="/"
              className="w-full bg-slate-100 text-slate-700 font-bold py-4 rounded-xl hover:bg-slate-200 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <Home size={20} />
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationFailed;
